import { CombinativClientAPI } from '@combinativ/client-api';

const windowObject = window as unknown as { combinativjs: CombinativClientAPI | undefined };

export function setupGlobalObject({ clientApi }: { clientApi: CombinativClientAPI }) {
    const previousObject = windowObject.combinativjs || {};
    windowObject.combinativjs = { ...previousObject, ...clientApi };
}
